import { TAppState, EPackageType } from '../types';
import { selectPackageType } from './buyPackageModal';
import { selectBillingUserType } from './selectBillingUserType';

export const selectIsHoldAvailable = (state: TAppState): boolean => {
  const billingUserType = selectBillingUserType(state);
  const packageType = selectPackageType(state);

  return billingUserType === 'natural' && packageType !== EPackageType.SpecialOffer;
};
